import InlineLoader from '../../common/components/Loader/InlineLoader'
import { Badge, Text } from '../../common/designs'
import { LogEvent } from './types'
import { formatTimestamp, getStatusIcon, getStatusVariant } from './utils'

interface ExportHistoryPanelProps {
  isTransferStarted: boolean
  hasFirstPollingResult: boolean
  events: LogEvent[]
}

const ExportHistoryPanel = ({
  isTransferStarted,
  hasFirstPollingResult,
  events,
}: ExportHistoryPanelProps) => {
  if (isTransferStarted && !hasFirstPollingResult) {
    return (
      <div className='flex items-center justify-center py-8'>
        <InlineLoader size='m' />
      </div>
    )
  }

  if (!events.length) {
    return (
      <Text size='s' className='text-gray-500'>
        No events to display
      </Text>
    )
  }

  return (
    <div className='flex flex-col gap-4'>
      {[...events].reverse().map(({ status, message, timestamp }, index) => {
        const variant = getStatusVariant(status)
        const icon = getStatusIcon(variant)

        return (
          <div
            key={index}
            className='flex items-center gap-2 border-b border-gray-200 pb-4 last:border-b-0'
          >
            {timestamp && (
              <Text size='xs' className='min-w-[140px] text-gray-500 '>
                {formatTimestamp(timestamp)}
              </Text>
            )}
            <Badge variant={variant} {...(icon && { icon })}>
              {status}
            </Badge>
            {message && (
              <Text size='s' className='text-gray-700'>
                {message}
              </Text>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default ExportHistoryPanel

